import React from "react";
import { PulseLoader } from 'react-spinners';

const LoadingSpinner = ({visible}) =><div style={{visibility:visible? 'visible':'hidden',position:'absolute', width:'90%',height:'90%',display: 'flex',
flexDirection: 'row',flexWrap: 'wrap',justifyContent: 'center',alignItems: 'center'}}
><PulseLoader size={20} margin={'4'} color={'blue'}/></div>

export default LoadingSpinner



// WEBPACK FOOTER //
// ./src/LoadingSpinner.js